// extracted by mini-css-extract-plugin
export var imageContainer = "styles-module--image-container--12026";
export var popupContainer = "styles-module--popup-container--8c237";
export var thumbs = "styles-module--thumbs--e4abb";
export var thumbsContainer = "styles-module--thumbs-container--598df";
export var topBar = "styles-module--top-bar--67601";